import React, { useEffect, useMemo } from 'react';

import { Field, FormikProps, useFormikContext } from 'formik';
import { ThemeProvider } from 'styled-components';

import {
  InputTextField,
  InputTextFieldTextarea,
  InputTextValidationLabel,
  InputTextWrapper,
} from './styled';

export interface TextInputProps extends FormikProps<any> {
  name: string;
  placeholder?: string;
  required?: boolean;
  textarea?: boolean;
  onBlur?: () => void;
}

export default function TextInput(props: TextInputProps) {
  const formikContext = useFormikContext();

  const isError = useMemo(() => {
    return formikContext.errors[props.name] && formikContext.touched[props.name];
  }, [formikContext.errors, formikContext.touched, props.name]);

  return (
    <ThemeProvider theme={{ isError }}>
      <InputTextWrapper>
        {props.required !== undefined ? (
          props.required ? (
            <InputTextValidationLabel>
              {isError ? formikContext.errors[props.name] : 'Required'}
            </InputTextValidationLabel>
          ) : (
            <InputTextValidationLabel>Optional</InputTextValidationLabel>
          )
        ) : null}
      </InputTextWrapper>
      <Field
        as={props.textarea ? InputTextFieldTextarea : InputTextField}
        {...props}
        onBlur={
          props.onBlur ? props.onBlur : () => formikContext.setFieldTouched(props.name, true, false)
        }
      />
    </ThemeProvider>
  );
}
